// SecondarySidebar에서 사용

import { useCommonStyles, sidebarTabsListProps } from '@/common/theme/css';
import { useProjectVisitHistory } from '@/common/hooks/useProjectVisitHistory';
import { Tabs, Text } from '@mantine/core';
import { useNavigate, useParams } from 'react-router-dom';
import { Project } from '../types';

const ProjectList = ({ projects }: { projects: Project[] }) => {
    const commonStyles = useCommonStyles();
    const { projectId: currentProjectId } = useParams();
    const navigate = useNavigate();

    // 최근 방문 순으로 프로젝트 정렬 (실시간 업데이트)
    const sortedProjects = useProjectVisitHistory(projects);

    const handleProjectClick = (project: Project) => {
        void navigate(`/project/${project.id}`);
    };

    return (
        <Tabs
            orientation="vertical"
            variant="pills"
            classNames={{
                tab: commonStyles.classes.secondarySidebarItem,
            }}
            value={currentProjectId || null}
        >
            <Tabs.List {...sidebarTabsListProps}>
                {sortedProjects.map(project => (
                    <Tabs.Tab
                        key={project.id}
                        value={project.id}
                        onClick={() => handleProjectClick(project)}
                        c={
                            currentProjectId === project.id
                                ? 'black'
                                : '#212529'
                        }
                    >
                        <Text size="xs" lineClamp={1} flex={1}>
                            {project.name}
                        </Text>
                    </Tabs.Tab>
                ))}
            </Tabs.List>
        </Tabs>
    );
};

export default ProjectList;
